@if (entity === "shgList") {
    <div class="three-dot" [matMenuTriggerFor]="menu">
        <img src="assets/images/threedot.svg" alt="three-dot" />
    </div>
    <mat-menu #menu="matMenu" class="mat-elevation-z3">
        @if (columnDetails?.showViewStatus && columnDetails?.showViewStatus?.length && columnDetails?.showViewStatus.includes(rowData.status)) {
            @for (action of columnDetails.default; track action) {
                <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
            }
        } @else {
            @for (action of columnDetails.actionLabels; track action) {
                <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
            }
        }
    </mat-menu>
}

@if (entity === "stallMemberList") {
    <div class="three-dot" [matMenuTriggerFor]="menu">
        <img src="assets/images/threedot.svg" alt="three-dot" />
    </div>
    <mat-menu #menu="matMenu" class="mat-elevation-z3">
        @for (action of columnDetails.actionLabels; track action) {
            @if (rowData.accommodation === "Yes" && action.name === "updateAccomodation") {
                <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
            }
            @if (rowData.accommodation === "No" && action.name === "addAccomodation") {
                <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
            }
        }
    </mat-menu>
}

@if (entity === "melaCoordinatorList") {
    @if (columnDetails.customCheckName === "coordinatorListAction") {
        <div class="three-dot" [matMenuTriggerFor]="menu">
            <img src="assets/images/threedot.svg" alt="three-dot" />
        </div>
        <mat-menu #menu="matMenu" class="mat-elevation-z3">
            @for (action of columnDetails.actionLabels; track action) {
                @if (rowData.accommodation === "Yes" && action.name === "updateAccomodation") {
                    <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
                } @else if (rowData.accommodation === "No" && action.name === "addAccomodation") {
                    <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
                } @else if (action.name === "replaceCoordinator") {
                    <p mat-menu-item (click)="actioncComponentEvent.emit({ action, rowData })">{{ action.name | translate }}</p>
                }
            }
        </mat-menu>
    }
}
